/**
 * VueLayers
 * Web map Vue components with the power of OpenLayers
 *
 * @package vuelayers
 * @author Vladimir Vershinin <ghettovoice@gmail.com>
 * @version 0.11.21
 * @license MIT
 * @copyright (c) 2017-2020, Vladimir Vershinin <ghettovoice@gmail.com>
 */
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';

function log() {
  var _console, _context;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  (_console = console).log.apply(_console, _concatInstanceProperty(_context = ['[VueLayers]']).call(_context, args));
}
function warn(msg) {
  var _console2, _context2;

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  (_console2 = console).warn.apply(_console2, _concatInstanceProperty(_context2 = ["[VueLayers] WARNING: ".concat(msg)]).call(_context2, args));
}
function error(msg) {
  var _console3, _context3;

  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  (_console3 = console).error.apply(_console3, _concatInstanceProperty(_context3 = ["[VueLayers] ERROR: ".concat(msg)]).call(_context3, args));
}

export { log, warn, error };
